export default __webpack_public_path__ + "static/media/activations.6fa831fa.svg";